/** Keep legacy row IDs local; the eligibility endpoint accepts and returns ARIs. */
export const toAttachmentActionAri = (
	id: string,
	cloudId: string,
	resourceType: 'attachment' | 'content',
): string => {
	if (id.startsWith('ari:')) {
		return id;
	}

	const resourceId = resourceType === 'attachment' ? id.replace(/^att(?=\d+$)/, '') : id;
	return `ari:cloud:confluence:${cloudId}:${resourceType}/${resourceId}`;
};
